<template>
  <div>
    <el-dialog
      visible
      v-if="templateFlag"
      :title="$t('templateForm.templateCreate')"
      @close="cancelTemplateClick"
    >
      <div>
        <div>{{ $t('templateForm.templateName') }}</div>
        <el-input v-model="templateName"></el-input>
      </div>
      <div slot="footer" class="bottom-buttons">
        <div></div>
        <div>
          <el-button class="button-cancel" type="plain" @click="cancelTemplateClick">{{ $t('templateForm.cancel') }}</el-button>
          <el-button class="button-confirm" type="success" @click="okTemplateClick">OK</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
     templateName: null
    };
  },
  methods: {
    okTemplateClick() {
      if (!this.templateName) {
        this.$store.commit("setError", this.$t('templateForm.enterTemplateName'));
      } else {
        this.$store
          .dispatch("insCronTemplate", this.templateName)
          .then(() => {
            this.$store.commit("setTemplateFlag", false);
            this.templateName = null;
            this.$store.commit("setTemplate", null);
          })
          .catch(() => {});
      }
    },
    cancelTemplateClick() {
      this.$store.commit('setTemplateFlag', false);
      this.templateName = null;
      this.$store.commit('setTemplate', null);
    },
  },
  computed: {
    ...mapGetters(["getAppsArray", 'templateFlag']),
  },
};
</script>

<style scoped>
</style>